export enum CyberAttackTypeEnum {
    DenialOfService = "DenialOfService",
    PortScanning = "PortScanning",
    DataExfiltration = "DataExfiltration",
    Ssh = "Ssh",
    Phishing = "Phishing",
    Ransomware = "Ransomware",
    Malware = "Malware",
    Spyware = "Spyware",
    Spam = "Spam",
    SqlInjection = "SqlInjection",
    BehavioralAbnormality = "BehavioralAbnormality"
}